export function findInArray(array, callback) {
    for (let i = 0, length = array.length; i < length; i++) {
        if (callback.apply(callback, [array[i], i, array])) {
            return array[i];
        }
    }
}

export function isFunction(func) {
    return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}

export function isNum(num) {
    return typeof num === 'number' && !isNaN(num);
}

export function isBool(bool) {
    return typeof bool === 'boolean';
}

export function int(a) {
    return parseInt(a, 10);
}

export function dontSetMe(props, propName, componentName) {
    if (props[propName]) {
        return new Error(`Invalid prop ${propName} passed to ${componentName} - do not set this, set it on the child.`);
    }
}
